export default "__VITE_ASSET__D9g$LWNe__"